import { Component, Input } from '@angular/core';
import { CountryModel } from 'lemunzo-api';
import { ElementWithOptionsModel } from '../../../models/clientsform/element-with-options';
import { CountrySelectComponent } from '../../country-select/country-select.component';

/**
 * Registration-specific semantic adapter around the generic country select component.
 */
@Component({
    selector: 'apcam-country-select-element',
    imports: [CountrySelectComponent],
    templateUrl: './country-select-element.component.html',
    styleUrl: './country-select-element.component.scss',
})
export class CountrySelectElementComponent {
    @Input({ required: true })
    public formcontrolName!: string;

    @Input({ required: true })
    public inputConfig!: ElementWithOptionsModel;

    @Input({ required: true })
    public countryList!: Map<string, CountryModel[]>;
}
